/**
 * @constant
 * @type {VideoProviderType}
 */
export const VideoProvider = {
  youtube: 'YOUTUBE',
  vimeo: 'VIMEO',
  cloudinary: 'CLOUDINARY',
};
